export enum NetworkPingState {
  PENDING,
  ONLINE,
  OFFLINE
}
